import { createStrictContext } from 'utils/createContext'
import {
  useIssueDispositionTypesMetadataQuery,
  useIssueDispositionTypesQuery,
} from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { IssueDispositionTypeContext } from './types'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } =
  createStrictContext<IssueDispositionTypeContext>('DispositionTypesContext')

export const useDispositionTypesContext = useContextFn

const DispositionTypesProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading, refetch } = useIssueDispositionTypesQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  const metadata = useIssueDispositionTypesMetadataQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  const types = useOptions({
    items: metadata.data?.project?.issueTypes,
    value: 'id',
    label: 'name',
    tooltip: 'description',
    sort: 'name',
  })
  return (
    <Provider
      value={{
        loading: loading ?? metadata.loading,
        refetch,
        dispositionTypes: data?.issueDispositionTypes?.records ?? [],
        types,
      }}
    >
      {children}
    </Provider>
  )
}

export default DispositionTypesProvider
